import { PRODUCTS } from "@/lib/catalog";
import { ProductCard } from "./ProductCard";
import { Eyebrow, Reveal } from "./Reveal";

export const Products = () => (
  <section id="shop" data-testid="shop-section" className="bg-[#F5F0E8] px-5 py-24 sm:px-8 lg:py-36">
    <div className="mx-auto max-w-[1400px]">
      <div className="mb-14 grid gap-8 lg:grid-cols-12 lg:items-end">
        <Reveal className="lg:col-span-7">
          <Eyebrow>The range · 03 balls</Eyebrow>
          <h2 className="font-display text-6xl font-black uppercase leading-[0.88] tracking-tight text-[#112E23] sm:text-7xl lg:text-8xl">
            Pick your <span className="font-serif-i normal-case font-normal text-[#6E472B]">colour.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="space-y-4 text-base leading-relaxed text-[#112E23]/80 sm:text-lg lg:col-span-5">
          <p>Every POW ball is made exactly the same way. The Splatter and Fluorescent balls are simply our white match balls with a splash of colour — nothing else is different.</p>
          <p>POW Balls are made for polocrosse players who want a quality, affordable ball for everyday play. Choose your preferred colour and quantity, then order online.</p>
        </Reveal>
      </div>

      <div className="grid gap-5 lg:grid-cols-12 lg:grid-rows-2">
        <div className="lg:col-span-7 lg:row-span-2">
          <ProductCard p={PRODUCTS[0]} featured index={0} />
        </div>
        <div className="lg:col-span-5">
          <ProductCard p={PRODUCTS[1]} index={1} />
        </div>
        <div className="lg:col-span-5">
          <ProductCard p={PRODUCTS[2]} index={2} />
        </div>
      </div>
      <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-[#112E23]/70">Prices in AUD · Australian postage added at checkout</p>
    </div>
  </section>
);
